import { render, staticRenderFns } from "./GolfPackageLinkPopup.vue?vue&type=template&id=58ec9ed8&"
import script from "./GolfPackageLinkPopup.vue?vue&type=script&lang=js&"
export * from "./GolfPackageLinkPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports